/* 2026-10-01 (Claude), Joel: "ship it" (option H) and "what if they want to view the product not add
   to cart" and "what do we do about variants though". Behaviour for the blade-page add-on cards
   (snippets/aoam-addon-card.liquid, look in assets/aoam-addon-cards.css):
     - the + ticks the card's hidden checkbox, which aoam-addons.js already adds with Add to Cart;
     - a card whose product has options (Acrylic Writer sizes, ...) never ticks blind: its + opens the
       quick look with chips, and the pick is written to the card's hidden [data-aoam-addon-variant]
       select, so aoam-addons.js adds exactly that variant;
     - the photo and name open the quick look; "See full details" opens the product in a new tab so
       the shopper's picks on this page survive.
   Roll back: see the header of aoam-addon-cards.css. */
(function () {
  if (window.__aoamAxc) return;
  window.aoamQlOpen = function (c) { open(c); }; /* 2026-10-12 audit R: lazy loader hook for the cart drawer rail */
  window.__aoamAxc = 1;

  var ov = null, cur = null, pick = 0, lastFocus = null, qlPress = false;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c, card) {
    var tmpl = (card && card.getAttribute('data-addon-price')) || '$0.00';
    // 2026-10-10 audit (market-currency): read decimals and the group mark from the template, so yen and won print whole units, kronor keep their space and US output is unchanged. Roll back: restore the old three lines (toFixed(2), the comma test, the comma grouping).
    var zero = !/[.,]\d{2}\D*$/.test(tmpl), comma = !zero && /\d,\d{2}\D*$/.test(tmpl);
    var a = zero ? String(Math.round(c / 100)) : (c / 100).toFixed(2);
    var gm = tmpl.match(/\d([^\d])\d{3}(?!\d)/), grp = gm ? gm[1] : (comma ? '' : ',');
    if (comma) a = a.replace('.', ',');
    if (grp) a = a.replace(/^\d+/, function (w) { return w.replace(/\B(?=(\d{3})+(?!\d))/g, grp); });
    return tmpl.replace(/\d[\d.,\s]*\d/, a);
  }
  // Short chip labels: "11 Inch (28cm)" -> 11 in / 28 cm, "Length: 1/2" - Width: 5/8" (...)" -> 5/8" wide.
  function short(t) {
    var m = /^(\d+)\s*Inch\s*\((\d+)\s*cm\)/i.exec(t);
    if (m) return [m[1] + ' in', m[2] + ' cm'];
    m = /Width:\s*([\d\/]+)"/i.exec(t);
    if (m) return [m[1] + '" wide', ''];
    return [t, ''];
  }
  function parts(card) {
    return {
      box: card.querySelector('[data-aoam-addon]'),
      sel: card.querySelector('[data-aoam-addon-variant]'),
      price: card.querySelector('[data-aoam-card-price]'),
      opt: card.querySelector('[data-aoam-opt]')
    };
  }
  function opts(card) {
    var s = parts(card).sel;
    if (!s) return [];
    return [].map.call(s.options, function (o, i) { return { i: i, id: o.value, p: +o.getAttribute('data-price'), t: o.textContent.trim(), v: (o.getAttribute('data-opts') || '').split('|') }; });
  }

  // Option names ("Type|Size|Length"). Two or more means one chip row per option, like the product page.
  function o_id(card, i) { var x = opts(card)[i]; return x ? x.id : ''; }
  function names(card) { return (card.getAttribute('data-ql-optnames') || '').split('|').filter(Boolean); }
  function label(card, x) { return names(card).length > 1 ? x.v.join(' · ') : short(x.t)[0]; }

  // Card face follows its checkbox: tick, lime edge, and the chosen option + price once added.
  function paint(card) {
    var P = parts(card), on = !!(P.box && P.box.checked);
    card.classList.toggle('is-on', on);
    var o = opts(card);
    if (!o.length) return;
    var cur = o[P.sel.selectedIndex] || o[0];
    if (P.opt) P.opt.textContent = on ? label(card, cur) : o.length + ' ' + (card.getAttribute('data-ql-unit') || 'options');
    // 2026-10-06 (Claude) D1 rows: a card on the product page rows carries data-card-from (the number alone, its grey "from" is separate markup).
    if (P.price) P.price.textContent = on ? money(cur.p, card) : (card.getAttribute('data-card-from') || card.getAttribute('data-ql-from') || P.price.textContent);
  }

  function build() {
    if (ov) return ov;
    ov = document.createElement('div');
    ov.className = 'aoam-ql-ov';
    // 2026-10-07 (Claude), Joel: "shiop your picks" (popup E). Gallery and info columns, a grab handle for the
    // phone sheet, an overline, a kit sub line, and the add + details buttons in one foot that pins on a phone.
    ov.innerHTML = '<div class="aoam-ql" role="dialog" aria-modal="true" aria-label="Quick look">' +
      '<span class="aoam-ql__grab" aria-hidden="true"></span>' +
      '<button type="button" class="aoam-ql__x" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"/></svg></button>' +
      '<div class="aoam-ql__gal"><img class="aoam-ql__main" alt=""><div class="aoam-ql__th"></div></div>' +
      '<div class="aoam-ql__info"><p class="aoam-ql__ov" hidden></p><p class="aoam-ql__n"></p><p class="aoam-ql__sub" hidden></p>' +
      '<p class="aoam-ql__p"></p><p class="aoam-ql__d"></p>' +
      '<p class="aoam-ql__ol" hidden></p><div class="aoam-ql__chips" hidden></div>' +
      '<div class="aoam-ql__foot"><button type="button" class="aoam-ql__add"></button>' +
      '<a class="aoam-ql__more" target="_blank" rel="noopener"></a></div></div></div>';
    document.body.appendChild(ov);
    // Keep clicks inside the dialog from reaching theme-level outside-click handlers.
    ov.addEventListener('click', onOv);
    return ov;
  }

  function sync() {
    if (!cur || cur.hasAttribute('data-aoam-qlkit')) return;
    var P = parts(cur), o = opts(cur), on = !!(P.box && P.box.checked);
    var has = o.length > 0, v = has ? o[pick] : null;
    ov.querySelector('.aoam-ql__p').textContent = has ? money(v.p, cur) : (cur.getAttribute('data-addon-price') || '');
    ov.querySelectorAll('.aoam-ql__chip[data-i]').forEach(function (c) { c.classList.toggle('is-sel', +c.getAttribute('data-i') === pick); });
    ov.querySelectorAll('.aoam-ql__chip[data-k]').forEach(function (c) { c.classList.toggle('is-sel', has && v.v[+c.getAttribute('data-k')] === c.getAttribute('data-val')); });
    ov.querySelectorAll('.aoam-ql__gl span').forEach(function (sp) { sp.textContent = has ? v.v[+sp.getAttribute('data-k')] : ''; });
    var ol = ov.querySelector('.aoam-ql__ol');
    if (has && names(cur).length < 2) ol.innerHTML = esc((cur.getAttribute('data-ql-unit') || 'option').replace(/s$/, '').replace(/^./, function (c) { return c.toUpperCase(); })) + ': <span>' + esc(short(v.t)[0]) + '</span>';
    var same = on && (!has || P.sel.selectedIndex === pick);
    var b = ov.querySelector('.aoam-ql__add');
    var direct = !P.box;
    b.textContent = direct ? 'Add to cart' : (same ? 'Added. Tap to remove' : (on && has ? 'Switch to ' + short(v.t)[0] : 'Add to my order'));
    b.classList.toggle('is-added', same);
    // 2026-10-08 (Claude) rail quick look: an option carrying data-img (a duster color, a variant photo) shows its own photo.
    var vi = has && P.sel.options[pick] && P.sel.options[pick].getAttribute('data-img');
    var vu = has && P.sel.options[pick] && P.sel.options[pick].getAttribute('data-url');
    if (vu) ov.querySelector('.aoam-ql__more').href = vu;
    if (vi) {
      ov.querySelector('.aoam-ql__main').src = vi;
      ov.querySelectorAll('.aoam-ql__th button').forEach(function (t) { t.classList.remove('is-sel'); });
    }
  }

  function open(card) {
    build();
    cur = card;
    lastFocus = document.activeElement;
    var P = parts(card), o = opts(card);
    pick = P.sel ? P.sel.selectedIndex : 0;
    var imgs = (card.getAttribute('data-ql-imgs') || '').split('|').filter(Boolean);
    var main = ov.querySelector('.aoam-ql__main');
    main.src = imgs[0] || '';
    main.alt = card.getAttribute('data-addon-title') || '';
    ov.querySelector('.aoam-ql__th').innerHTML = imgs.length > 1 ? imgs.map(function (u, i) {
      return '<button type="button" class="' + (i ? '' : 'is-sel') + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(u) + '" alt="" loading="lazy"></button>';
    }).join('') : '';
    // 2026-10-07 (Claude) popup E: the last two words of the name and description never split (no widows).
    ov.querySelector('.aoam-ql__n').textContent = (card.getAttribute('data-addon-title') || '').replace(/ (\S+)$/, '\u00a0$1');
    var d = (card.getAttribute('data-ql-desc') || '').replace(/\s+/g, ' ').trim();
    var cut = d.indexOf('. ', d.indexOf('. ') + 2);
    ov.querySelector('.aoam-ql__d').textContent = (cut > 0 ? d.slice(0, cut + 1) : d).replace(/ (\S+)$/, '\u00a0$1');
    ov.querySelector('.aoam-ql__more').href = card.getAttribute('data-ql-url') || '#';
    // 2026-10-07 (Claude) popup E: overline from the row heading. A kit card (aoam-pdp-rows.liquid,
    // data-aoam-qlkit) has nothing to tick here, so it shows its contents line and price, hides the add
    // button and makes "See full details" the lime button, opening the kit in the same tab.
    var row = card.closest('.pdpc-row, .aoam-addons, .axc-generic, .accessory-block-pro-list'), hd = row && row.querySelector('.pdpc-hd b, .aoam-ax__h, .axc-drawer-note'); /* 2026-10-12 audit R: the cart drawer rail's 'Add to your order' note is the overline */
    var ovl = ov.querySelector('.aoam-ql__ov');
    ovl.textContent = hd ? hd.textContent.replace(/\s+/g, ' ').trim() : '';
    ovl.hidden = !ovl.textContent;
    var kit = card.hasAttribute('data-aoam-qlkit'), sub = ov.querySelector('.aoam-ql__sub'), more = ov.querySelector('.aoam-ql__more');
    sub.textContent = kit ? (card.getAttribute('data-ql-sub') || '') : '';
    sub.hidden = !sub.textContent;
    ov.querySelector('.aoam-ql__add').hidden = kit;
    more.classList.toggle('is-primary', kit);
    if (kit) {
      more.removeAttribute('target'); more.removeAttribute('rel');
      more.textContent = 'See full details';
      var sv = card.getAttribute('data-ql-save');
      ov.querySelector('.aoam-ql__p').innerHTML = (card.hasAttribute('data-ql-varies') ? '<small>from</small>' : '') + esc(card.getAttribute('data-ql-from') || '') + (sv ? '<em>Save ' + esc(sv) + '</em>' : '');
    } else {
      more.target = '_blank'; more.rel = 'noopener';
      more.innerHTML = 'See full details <span aria-hidden="true">&#8599;</span>';
    }
    var ch = ov.querySelector('.aoam-ql__chips'), ol = ov.querySelector('.aoam-ql__ol');
    var N = names(card);
    ch.hidden = ol.hidden = !o.length;
    ch.classList.toggle('is-groups', N.length > 1);
    if (N.length > 1) {
      ol.hidden = true;
      ch.innerHTML = N.map(function (nm, k) {
        var seen = [];
        o.forEach(function (x) { if (x.v[k] != null && seen.indexOf(x.v[k]) < 0) seen.push(x.v[k]); });
        return '<p class="aoam-ql__gl">' + esc(nm) + ': <span data-k="' + k + '"></span></p><div class="aoam-ql__row">' + seen.map(function (val) {
          return '<button type="button" class="aoam-ql__chip" data-k="' + k + '" data-val="' + esc(val) + '"><b>' + esc(val).replace(/ (?=[^ ]*$)/, '\u00a0') + '</b></button>';
        }).join('') + '</div>';
      }).join('');
    } else ch.innerHTML = o.map(function (x) {
      var s = short(x.t);
      // 2026-10-10 audit (picker-prices): 3+ options print the cheapest at its real price and every other chip as +$X over it, never a minus (same rule as the product page pills in snippets/variant-button.liquid); 2 options keep real prices, ties at the cheapest keep the real price. Roll back: make pr = money(x.p, card).
      var mn = Math.min.apply(null, o.map(function (y) { return y.p; }));
      var pr = (o.length >= 3 && isFinite(mn) && x.p > mn) ? '+' + money(x.p - mn, card).replace(/[.,]00(?=\D*$)/, '') : money(x.p, card);
      return '<button type="button" class="aoam-ql__chip" data-i="' + x.i + '"><b>' + esc(s[0]).replace(/ (?=[^ ]*$)/, '\u00a0') + '</b>' + (s[1] ? '<small>' + esc(s[1]) + '</small>' : '') + '<small>' + esc(pr) + '</small></button>';
    }).join('');
    sync();
    ov.classList.add('is-open');
    document.documentElement.classList.add('aoam-ql-lock');
    var x = ov.querySelector('.aoam-ql__x');
    if (x) x.focus({ preventScroll: true });
  }

  function close(noFocus) {
    if (!ov) return;
    ov.classList.remove('is-open');
    document.documentElement.classList.remove('aoam-ql-lock');
    if (noFocus === true) return; // the cart drawer is opening, leave focus to it
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  function setOn(card, on, idx) {
    var P = parts(card);
    if (P.sel && idx != null && P.sel.selectedIndex !== idx) {
      P.sel.selectedIndex = idx;
      P.sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (P.box && P.box.checked !== on) {
      P.box.checked = on;
      P.box.dispatchEvent(new Event('change', { bubbles: true }));
    }
    paint(card);
  }

  function onOv(e) {
    e.stopPropagation();
    if (e.target === ov || e.target.closest('.aoam-ql__x')) { close(); return; }
    if (ov.querySelector('.aoam-ql__add.is-loading')) return; // 2026-10-09 mid-add: no chip changes until it lands
    var t = e.target.closest('.aoam-ql__th button');
    if (t) {
      ov.querySelectorAll('.aoam-ql__th button').forEach(function (b) { b.classList.remove('is-sel'); });
      t.classList.add('is-sel');
      ov.querySelector('.aoam-ql__main').src = t.querySelector('img').src;
      return;
    }
    var c = e.target.closest('.aoam-ql__chip');
    if (c && c.hasAttribute('data-k')) {
      var k = +c.getAttribute('data-k'), val = c.getAttribute('data-val'), o = opts(cur), want = o[pick].v.slice();
      want[k] = val;
      var hit = o.filter(function (x) { return x.v.join('|') === want.join('|'); })[0] || o.filter(function (x) { return x.v[k] === val; })[0];
      if (hit) pick = hit.i;
      sync(); return;
    }
    if (c) { pick = +c.getAttribute('data-i'); sync(); return; }
    if (e.target.closest('.aoam-ql__add')) {
      var P = parts(cur), has = !!P.sel, on = !!(P.box && P.box.checked);
      if (!P.box) {
        var btn = cur.querySelector('.axc-add');
        // 2026-10-08 (Claude) rail quick look: the + adds the card's own variant, so point it at the chosen one for this add only.
        if (btn && has && o_id(cur, pick)) {
          var was = btn.getAttribute('data-variant-id');
          btn.setAttribute('data-variant-id', o_id(cur, pick));
          setTimeout(function () { btn.setAttribute('data-variant-id', was); }, 2500);
        }
        /* 2026-10-09 (Claude), Joel: "if i add an upsell product from the product page and the cart opens there hsould be spinning wheel showing it even if i have to go through the variant picker pop up". The quick look used to shut 350ms after the press, before the add answered, so the card's wheel spun behind it unseen. Now its Add button carries the wheel and the sheet stays up until the card's + leaves .is-loading (aoamUpsellAdd drops it the moment the cart drawer is told to open), then closes without pulling focus back off the drawer. 10s backstop. Roll back: restore the one line "if (btn) { qlPress = true; try { btn.click(); } finally { qlPress = false; } } setTimeout(close, 350); return;". */
        if (!btn) { setTimeout(close, 350); return; }
        var qb = e.target.closest('.aoam-ql__add'), t0 = Date.now(), mine = cur;
        qb.classList.add('is-loading');
        qlPress = true; try { btn.click(); } finally { qlPress = false; }
        (function wait() {
          if (btn.classList.contains('is-loading') && Date.now() - t0 < 10000) { setTimeout(wait, 60); return; }
          qb.classList.remove('is-loading');
          if (cur === mine && ov.classList.contains('is-open')) close(true); // shut by hand and reopened on another card: leave it
        })();
        return;
      }
      if (on && (!has || P.sel.selectedIndex === pick)) setOn(cur, false);
      else { setOn(cur, true, has ? pick : null); setTimeout(close, 350); }
      sync();
    }
  }

  document.addEventListener('click', function (e) {
    // 2026-10-07 (Claude): a kit card's photo opens the quick look; the rest of the card, the keyboard and a
    // ctrl/shift/cmd click still open the kit page.
    var kq = !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.target.closest && e.target.closest('a.pdpc-link[data-aoam-qlkit] .axc-ph');
    if (kq) { e.preventDefault(); e.stopPropagation(); open(kq.closest('a.pdpc-link')); return; }
    var q = e.target.closest && e.target.closest('.aoam-axc [data-aoam-ql]');
    if (q) { e.preventDefault(); open(q.closest('.aoam-axc')); return; }
    // A card with options must be picked in the quick look, never ticked blind.
    var add = e.target.closest && e.target.closest('.aoam-axc .axc-add, .axc--pick .axc-add'); /* 2026-10-12 audit R: drawer rail cards with options (.axc--pick) open the quick look too */
    if (add) {
      var card = add.closest('.aoam-axc, .axc--pick'), P = parts(card);
      if (P.sel && P.box && !P.box.checked) { e.preventDefault(); open(card); }
      // 2026-10-09 (Claude): a product page row card (no checkbox, its + adds straight to the cart) with options opens the quick look too, unless the quick look itself is pressing it.
      if (P.sel && !P.box && !qlPress) { e.preventDefault(); e.stopPropagation(); open(card); }
    }
  }, true);

  document.addEventListener('change', function (e) {
    var card = e.target.closest && e.target.closest('.aoam-axc');
    if (card) paint(card);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov && ov.classList.contains('is-open')) close(); });

  // 2026-10-09 (Claude), Joel: "drag down to close these quickviews". Phone sheet only (under 768px, where the
  // grab handle shows). A downward pull starts only while the sheet is scrolled to its top and the gesture is
  // more vertical than sideways (the thumbnail strip still pans). Past 90px, or a quick flick, it slides off and
  // closes; otherwise it springs back. Inline styles only, cleared on every end, so nothing lingers on reopen.
  // Roll back: delete this block.
  (function () {
    var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    var sy = 0, sx = 0, st = 0, dy = 0, mode = 0, sheet = null; // mode 0 undecided, 1 dragging, -1 ignore
    function reset(s) { s.style.transition = ''; s.style.transform = ''; ov.style.background = ''; }
    document.addEventListener('touchstart', function (e) {
      mode = -1;
      if (!ov || !ov.classList.contains('is-open') || !mq || !mq.matches || e.touches.length !== 1) return;
      sheet = ov.querySelector('.aoam-ql');
      if (!sheet || !sheet.contains(e.target) || sheet.scrollTop > 0) return;
      sy = e.touches[0].clientY; sx = e.touches[0].clientX; st = Date.now(); dy = 0; mode = 0;
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (mode < 0) return;
      var y = e.touches[0].clientY - sy, x = e.touches[0].clientX - sx;
      if (mode === 0) {
        if (Math.abs(y) < 6 && Math.abs(x) < 6) return;
        if (y <= 0 || Math.abs(x) > Math.abs(y) || sheet.scrollTop > 0) { mode = -1; return; }
        mode = 1; sheet.style.transition = 'none';
      }
      dy = Math.max(0, y);
      if (e.cancelable) e.preventDefault();
      sheet.style.transform = 'translateY(' + dy + 'px)';
      ov.style.background = 'rgba(0, 0, 0, ' + (0.6 * Math.max(0, 1 - dy / sheet.offsetHeight)).toFixed(3) + ')';
    }, { passive: false });
    function end() {
      if (mode !== 1) { mode = -1; return; }
      mode = -1;
      var s = sheet, fast = dy > 30 && dy / Math.max(1, Date.now() - st) > 0.5;
      s.style.transition = 'transform .22s ease-out';
      if (dy > 90 || fast) {
        s.style.transform = 'translateY(100%)';
        setTimeout(function () { close(); reset(s); }, 220);
      } else {
        s.style.transform = 'translateY(0)';
        ov.style.background = '';
        setTimeout(function () { reset(s); }, 230);
      }
    }
    document.addEventListener('touchend', end, { passive: true });
    document.addEventListener('touchcancel', end, { passive: true });
  })();

  function init() { document.querySelectorAll('.aoam-axc').forEach(paint); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
